package com.elan.edubridge.ui.shell

/**
 * `/invite#c=` — 앱 미설치 대응 초대 착지 화면.
 *
 * 🔴 보안: 초대 코드는 프래그먼트(`c`)에만 두며, 웹에서는 절대 읽지 않는다. 초대 수락은 앱에서만
 * 처리한다. [render]가 매개변수를 받지 않아 코드가 변수·로그·네트워크 요청에 들어갈 경로가 없다.
 */
object InvitationLandingPage {
    fun render() {
        renderPage("eb-qr-landing", html())
    }

    private fun html(): String = """
        ${icon("icon-bridge-logo", "xl")}
        <h1>EduBridge 앱에서 초대를 수락할 수 있어요</h1>
        <p class="eb-meta">아래에서 앱을 설치한 뒤, 이 링크를 다시 탭하세요.</p>
        ${studentAppBadges()}
    """.trimIndent()
}
